/**
 * Ключи идемпотентности для изменяющих запросов к Core.
 *
 * Создающие и «тяжёлые» операции Core требуют заголовок `Idempotency-Key`:
 * повторная отправка того же намерения после сбоя сети не должна создать дубль.
 * Модуль — единственное место, где ключ порождается и превращается в
 * заголовок; раньше эту пару функций копировал каждый API-класс.
 */

/** Новый ключ: UUID, а если `crypto.randomUUID` недоступен — временная метка со случайным хвостом. */
export function newIdempotencyKey(): string {
  return (
    globalThis.crypto?.randomUUID?.() ??
    `web-${Date.now()}-${Math.random().toString(16).slice(2)}`
  );
}

/**
 * Заголовок с ключом. Ключ, переданный вызывающим, сохраняется между повторами
 * одного намерения; без него берётся новый, поэтому два независимых нажатия
 * никогда не делят один статический ключ.
 */
export function idempotencyHeaders(key?: string): HeadersInit {
  return { "Idempotency-Key": key ?? newIdempotencyKey() };
}
